import { render, staticRenderFns } from "./ResourcesIndex.vue?vue&type=template&id=02d49fb1&"
import script from "./ResourcesIndex.vue?vue&type=script&lang=js&"
export * from "./ResourcesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports